import React from 'react';
import './styles.scss'
const LoadingBar = () => {
  return (
    <div className="loading-bar-container">
      <div className="loading-bar"></div>
    </div>
  );
};

export default LoadingBar;
